<template>
   <v-row>
    <v-col
      >
  <v-select
    label='Classroom'
    class="white"
    :items="data"
    item-text="name"
    item-value="id"
    :loading="api.isLoading"
    v-model="id"
  ></v-select>
  </v-col>
   </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["institutionId","callbackSelect"],
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    data: [],
    id: null,
    item: null,
  }),
  created() {
    //BOC:[api]
    this.api.method = "get";
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
      //BOC:[parent]
      this.callbackError(e);
      //EOC
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.data = resp;
      if(this.institutionId != this.$route.params.grandParentId){
        this.id = resp[0].id;
      }else{
        this.id = this.$route.params.parentId
      }
    };
    //EOC
  },
   computed: {
    ...mapState({
      school: (state) => state.school.data,
    }),
  },
  watch: {
    id: function (val) {
      this.callbackSelect(val);
    },
  },
  methods: {
    fetch() {
      this.api.url =`${this.$api.servers.sso}/api/v1/en/data/institution/${this.institutionId}/classroom`
      this.$api.fetch(this.api);
    },
  },
};
</script>
